"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var uniqWith_1 = __importDefault(require("lodash/uniqWith"));
var KnowledgeModel = /** @class */ (function (_super) {
    __extends(KnowledgeModel, _super);
    function KnowledgeModel(knowledge, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = knowledge.id;
        _this.name = knowledge.name;
        _this.parentId = knowledge.parentId;
        // These are the RGBA colors used in dex-essays correction view
        _this._colors = {
            9496: [254, 213, 0],
            9497: [251, 123, 1],
            9498: [38, 159, 249],
            9499: [102, 255, 189],
            9500: [237, 106, 180],
        };
        return _this;
    }
    Object.defineProperty(KnowledgeModel.prototype, "parent", {
        get: function () {
            return this.getters.knowledgeById(this.parentId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KnowledgeModel.prototype, "ancestors", {
        get: function () {
            return this.parent.id ? [this.parent].concat(this.parent.ancestors) : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KnowledgeModel.prototype, "children", {
        get: function () {
            return this.getters.knowledgesByParentId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KnowledgeModel.prototype, "descendants", {
        get: function () {
            return this.children.reduce(function (descendants, child) { return descendants.concat(child.descendants); }, this.children);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KnowledgeModel.prototype, "associations", {
        get: function () {
            return this.getters.associationsByKnowledgeId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KnowledgeModel.prototype, "questions", {
        get: function () {
            return this.associations.filter(function (association) { return association.questionId; }).map(function (association) { return association.question; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KnowledgeModel.prototype, "lists", {
        get: function () {
            var entityComparison = function (A, B) { return A.id === B.id; };
            var questions = this.descendants.reduce(function (questions, descendant) { return questions.concat(descendant.questions); }, this.questions);
            var lists = questions.reduce(function (lists, question) { return lists.concat(question.lists); }, []);
            return uniqWith_1.default(lists, entityComparison);
        },
        enumerable: false,
        configurable: true
    });
    KnowledgeModel.prototype.listsByUser = function (userId) {
        return this.lists.filter(function (list) { return list.userId === userId; });
    };
    KnowledgeModel.prototype.color = function (highlighted) {
        if (highlighted === void 0) { highlighted = true; }
        var color = this._colors[this.id].join(', ');
        return "rgba(" + color + ", " + (highlighted ? 0.5 : 0.1) + ")";
    };
    return KnowledgeModel;
}(Model_1.default));
exports.KnowledgeModel = KnowledgeModel;
